import { Collapse, Form, Select } from "antd";
import BbotAccordion from "top-component-library/BbotAccordion";

import { ACTION_NAMES, ACTION_ORDER, PERMISSION_LEVEL_OPTIONS } from "../constants";

// User Permissions matrix: one row per action (rendered in ACTION_ORDER), each choosing the
// minimum required user level, stored under permissions[action]. Legacy permission keys not in
// ACTION_ORDER are preserved on save (see mergeEditedConfig) but intentionally not shown here.
const UserPermissionsSection = () => (
  <BbotAccordion>
    <Collapse.Panel header="User Permissions" key="user-permissions">
      <div className="margin-bottom-2">
        <em>Note: Permissions configuration supported in Terminal 3.1+</em>
      </div>
      {ACTION_ORDER.map((action) => (
        <Form.Item key={action} name={["permissions", action]} label={ACTION_NAMES[action]}>
          <Select
            id={`dp-permission-${action}`}
            options={PERMISSION_LEVEL_OPTIONS}
            placeholder="Select Permission Level"
          />
        </Form.Item>
      ))}
    </Collapse.Panel>
  </BbotAccordion>
);

export default UserPermissionsSection;
